import TopicTrends from './TopicTrends';

export default TopicTrends;
